var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"note__person"},[_c('div',{staticClass:"note__name"},[_vm._v(_vm._s(_vm.person.name))]),_vm._v(" "+_vm._s(_vm.person.note)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }